import { createFileRoute } from '@tanstack/react-router'

type JobSearchParams = {
  query?: string
  location?: string
  jobType?: string
  experienceLevel?: string
  page?: number
  limit?: number
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
  salaryMin?: number
  salaryMax?: number
  source?: 'all' | 'internal' | 'external'
  mode?: 'ai' | 'browse'
}

export const Route = createFileRoute('/$locale/jobs')({
  ssr: false, // CSR only - no SEO needed
  validateSearch: (search: Record<string, unknown>): JobSearchParams => ({
    query: (search.query as string) || undefined,
    location: (search.location as string) || undefined,
    jobType: (search.jobType as string) || undefined,
    experienceLevel: (search.experienceLevel as string) || undefined,
    page: Number(search.page) || 1,
    limit: Number(search.limit) || 20,
    sortBy: (search.sortBy as string) || 'datePosted',
    sortOrder: (search.sortOrder as 'asc' | 'desc') || 'desc',
    salaryMin: search.salaryMin ? Number(search.salaryMin) : undefined,
    salaryMax: search.salaryMax ? Number(search.salaryMax) : undefined,
    source: (['all', 'internal', 'external'].includes(search.source as string)
      ? (search.source as 'all' | 'internal' | 'external')
      : undefined),
    mode: (['ai', 'browse'].includes(search.mode as string)
      ? (search.mode as 'ai' | 'browse')
      : undefined),
  }),
})
